var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module_wrap box_border"},[_c('div',{staticClass:"box_title box_title_radio"},[_c('span',[_vm._v("结案时长分布")])]),_c('div',{attrs:{"id":"lawsuit_times_pie"}})])
}]

export { render, staticRenderFns }